import { useSiteInfoStore } from 'stores/site-info'
import { boot } from 'quasar/wrappers'

export default boot(async ({ router, urlPath }) => {
  const siteInfoStore = useSiteInfoStore()

  const route = router.resolve(decodeURIComponent(urlPath))
  if (!route) {
    return
  }

  const underAttack = siteInfoStore.getFullCheck
  const session = localStorage.getItem('ussidcs-tmp')
  if (underAttack && session) {
    return router.replace({ name: 'session-auth', query: { url: route.fullPath } })
  }
})
